export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Easy-return.57fec039.svg","height":88,"width":117,"blurWidth":0,"blurHeight":0};